


























































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import PasswordReminderApi from '@/app/model/api/passwordReminderApi'
/* module */
import Local from '@/app/module/local'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    ErrorInfo
  }
})
export default class PasswordReminder extends Vue {
  private email:string = ''
  private errorMessages: string = ''
  private alertText: string = ''
  private showAlert: boolean = false
  private showComplate: boolean = false
  private show400ErrorMessage: boolean = false

  private async sendEmail () {
    if (this.isSendEmail()) {
      const bodyData = {
        'mailaddress': this.email
      }

      const result = await PasswordReminderApi.sendEmail(bodyData)
      if (result.isOk()) {
        this.showComplate = true
      } else if (result.getPayload().status_code === '400') {
        // バリデーションエラー(alert表示)
        let errors: any = []
        errors.push('<ul>')
        for (var i in result.getPayload().errors) {
          errors.push('<li>' + result.getPayload().errors[i].message + '</li>')
        }
        errors.push('</ul>')
        this.alertText = errors.join('')
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      } else {
        // 500系とその他
        this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
      }
    } else {
      this.alertText = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }

  private isSendEmail () {
    const flag = Validator.validateInputEmail('emailErrorMessage', this.email)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return flag
  }
}
